export default {
  "content": "<path d=\"M0 0h24v24H0z\" fill=\"none\"/><path class=\"path\" d=\"M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "height": "24",
    "viewBox": "0 0 24 24",
    "width": "24"
  }
};